import React from 'react';
import {Container} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faUserDoctor, faUser, faShieldHalved,
    faPrescriptionBottleMedical, faFileLines
} from '@fortawesome/free-solid-svg-icons';
import dogImage from '../../assets/images/Doctor-Dog.png';

const steps = [
    {
        icon: faUser,
        title: 'Reads the patient',
        plain: 'Picks up the facts that matter - age, sex, kidney function.',
        evidence: '70-year-old female · eGFR 30 (impaired kidney function)'
    },
    {
        icon: faShieldHalved,
        title: 'Checks what\'s unsafe',
        plain: 'Rules out treatments that would be dangerous for this patient.',
        evidence: 'First-line option excluded - contraindicated in renal impairment'
    },
    {
        icon: faPrescriptionBottleMedical,
        title: 'Picks the right treatment',
        plain: 'Selects the option that\'s safe and matches national guidance.',
        evidence: 'Selects the NICE-recommended alternative at the correct dose'
    },
    {
        icon: faFileLines,
        title: 'Shows its working',
        plain: 'Every step recorded - what it saw, what it ruled out, why it chose what it chose.',
        evidence: 'Full audit trail cited back to source guidelines'
    }
];

const DoctorDogScenarioSection = () => (
    <section id="doctor-dog-scenario" className="py-5">
        <Container>
            <div className="text-center mb-5">
                <div className="section-label">See It Work</div>
                <h2>One decision. Fully explained. Fully auditable.</h2>
                <p className="section-intro">
                    Here is an example for a clinical use-case.
                    AgentDOG configured as a clinicians assistant doing the first stage of single clinical decision.
                    Supporting the clinical workflow, deferring to clinicians for final judgement.
                </p>
                <p className="section-intro">
                    Same pattern works for legal advice, financial suitability,
                    regulatory checks - anywhere a decision has to be both fast
                    and defensible.
                </p>
            </div>

            <div className="product-row">
                <div className="product-row-visual">
                    <div className="product-row-header bg-gradient">
                        <div className="product-card-header-orb"/>
                        <div className="product-card-header-inner">
                            <div className="product-card-icon-box">
                                <FontAwesomeIcon icon={faUserDoctor}/>
                            </div>
                            <div>
                                <div className="product-card-name">Doctor Dog</div>
                                <div className="product-card-tag">A WORKED EXAMPLE</div>
                            </div>
                        </div>
                    </div>
                    <div className="product-row-image">
                        <img src={dogImage} alt="AgentDOG - Doctor Dog scenario"/>
                    </div>
                </div>

                <div className="product-row-content">
                    <div className="doctor-dog-scenario-intro">
                        <div className="doctor-dog-scenario-label">THE SCENARIO</div>
                        <p className="doctor-dog-scenario-text">
                            An older patient walks into a GP surgery with a urinary
                            infection. She has reduced kidney function, which changes
                            what's safe to prescribe. The agent has to work out the
                            right treatment - and show why.
                        </p>
                    </div>

                    <ol className="doctor-dog-steps">
                        {steps.map((s, i) => (
                            <li key={i} className="doctor-dog-step">
                                <div className="doctor-dog-step-icon">
                                    <FontAwesomeIcon icon={s.icon}/>
                                </div>
                                <div className="doctor-dog-step-body">
                                    <div className="doctor-dog-step-num">STEP {String(i + 1).padStart(2, '0')}</div>
                                    <h4 className="doctor-dog-step-title">{s.title}</h4>
                                    <p className="doctor-dog-step-plain">{s.plain}</p>
                                    <p className="doctor-dog-step-evidence">{s.evidence}</p>
                                </div>
                            </li>
                        ))}
                    </ol>

                    <div className="doctor-dog-stats">
                        <div className="doctor-dog-stat">
                            {/*<FontAwesomeIcon icon={faBolt} className="doctor-dog-stat-icon"/>*/}
                            <div className="doctor-dog-stat-value">SME Controlled</div>
                            <div className="doctor-dog-stat-label">Doctors/Clinician judgement on decisions</div>
                        </div>
                        <div className="doctor-dog-stat">
                            <div className="doctor-dog-stat-value">Cited</div>
                            <div className="doctor-dog-stat-label">Every step traced to source</div>
                        </div>
                        <div className="doctor-dog-stat">
                            <div className="doctor-dog-stat-value">Reviewable</div>
                            <div className="doctor-dog-stat-label">A clinician can check the working</div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    </section>
);

export default DoctorDogScenarioSection;